// Document validation alerts functionality
document.addEventListener("DOMContentLoaded", function() {
  // Add close button functionality to missing fields alerts
  const alerts = document.querySelectorAll('.bg-red-50, .dark\\:bg-red-900\\/20');
  
  alerts.forEach(alert => {
    // Check if this is a missing fields alert (contains our specific structure)
    const alertTitle = alert.querySelector('h3');
    if (alertTitle && alertTitle.textContent.trim() === 'Champs manquants') {
      // Add close functionality
      addCloseButton(alert);
      
      // Add animation classes
      alert.classList.add('transition-all', 'duration-300', 'ease-in-out');
    }
  });
});

function addCloseButton(alert) {
  const closeButton = document.createElement('button');
  closeButton.innerHTML = `
    <svg class="h-4 w-4 text-red-400 hover:text-red-600" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
    </svg>
  `;
  closeButton.className = 'ml-auto flex-shrink-0 p-1 rounded-md hover:bg-red-100 dark:hover:bg-red-800 transition-colors';
  closeButton.setAttribute('aria-label', 'Fermer');
  
  // Find the flex container and add the close button
  const flexContainer = alert.querySelector('.flex');
  if (flexContainer) {
    flexContainer.appendChild(closeButton);
  }
  
  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
    closeAlert(alert);
  });
}

function closeAlert(alert) {
  alert.style.opacity = '0';
  alert.style.maxHeight = '0';
  alert.style.paddingTop = '0';
  alert.style.paddingBottom = '0';
  alert.style.marginBottom = '0';
  
  setTimeout(() => {
    alert.remove();
  }, 300);
}

// Refresh alerts when form data changes (if you have form inputs in the member page)
function refreshDocumentAlerts() {
  // This function can be called when member data is updated via AJAX
  // to refresh the missing fields alerts
  window.location.reload();
}
